import api from '~/utils/api';
import constantCreator, { promiseStates } from '~/utils/constantsCreator';

const constant = constantCreator.defineAction('lx').defineAction;
const GET_DATA = constant('GET_DATA', promiseStates);

const initialState = {
  loading: false,
  data: {},
  isError: false,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_DATA.PENDING:
      return {
        ...state,
        loading: true,
      };
    case GET_DATA.RESOLVED:
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          [action.slug]: {
            ...action.data,
            loaded: true,
          },
        },
        isError: false,
        error: null,
      };
    case GET_DATA.REJECTED:
      return {
        ...state,
        loading: false,
        isError: true,
        error: action.error,
      };
    default:
      return state;
  }
}
/*
  export function isLoaded(globalState) {
  return globalState.lxprofile && globalState.lxprofile.loaded;
*/

export default reducer;

export const actions = {
  getLxData: slug => ({
    promise: api.get(`/users/local-expert/${slug}`),
    type: GET_DATA,
    slug,
  }),
};
